import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.tsx'
import AdminAccess from './components/AdminAccess.tsx'
// UserManagementPage is now integrated into AdminDashboard
import MyBookingsPage from './components/MyBookingsPage.tsx'
import AboutPageWrapper from './components/AboutPageWrapper.tsx'
import BaseBookingsPage from './components/BaseBookingsPage'; // Using consolidated BaseBookingsPage
import TermsPage from './pages/TermsPage.tsx'; // Added import
import PrivacyPage from './pages/PrivacyPage.tsx'; // Added import
import DefaultPage from './pages/DefaultPage';
import ProtectedRoute from './components/ProtectedRoute.tsx'; // Import ProtectedRoute
import './index.css'
import './styles/shared.css'
import './styles/Form.module.css'
import './styles/BookingForm.module.css'
import './shared/component/Authentication/styles.css'
import './styles/input-variants.css'
import { RoleProvider } from './context/RoleContext'
import { ThemeProvider } from './context/ThemeContext' // Import ThemeProvider
import GoogleMapsProvider from './components/GoogleMapsProvider'; // Import GoogleMapsProvider
import AnalyticsTracker from './components/AnalyticsTracker'
import NotFoundRedirect from './components/NotFoundRedirect'; // Import the new component
import LoginPage from './pages/LoginPage'; // Import LoginPage
import AuthCallbackPage from './pages/AuthCallback'; // Import AuthCallbackPage
import ResetPasswordPage from './pages/ResetPasswordPage';
import MagicLinkPage from './pages/MagicLinkPage';
import ServiceWorkerRegistration from './PWA/ServiceWorkerRegistration'; // Import ServiceWorkerRegistration

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider> {/* Wrap with ThemeProvider */}        <GoogleMapsProvider> {/* Wrap with GoogleMapsProvider */}
            <RoleProvider>
              <AnalyticsTracker />
              <ServiceWorkerRegistration />
              <Routes>
              {/* Auth routes MUST be first and exactly match to prevent parameter capture */}
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/auth/*" element={<AuthCallbackPage />} />

              {/* Login route */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/magic-link" element={<MagicLinkPage />} />

              {/* Admin route needs to be first to avoid conflict with service routes */}
              <Route path="/:serviceKey/system/admin" element={
                <ProtectedRoute allowedRoles={['superadmin']}>
                  <AdminAccess />
                </ProtectedRoute>
              } />

              {/* User Management is now integrated into AdminDashboard */}

              {/* Base-bookings route - specific route for service provider admins */}
              <Route path="/:serviceKey/base-bookings/*" element={
                <ProtectedRoute allowedRoles={['serviceprovideradmin', 'superadmin']}>
                  {/* <AdminAccess /> */}
                  <BaseBookingsPage /> {/* Using consolidated BaseBookingsPage */}
                </ProtectedRoute>
              } />
            {/* Bookings route - needs to be before the main service route */}
              <Route path="/:serviceKey/bookings/*" element={<MyBookingsPage />} />

              {/* About page route */}
              <Route path="/:serviceKey/about" element={<AboutPageWrapper />} />

              {/* Terms and Privacy page routes */}
              <Route path="/:serviceKey/terms" element={<TermsPage />} />
              <Route path="/:serviceKey/privacy" element={<PrivacyPage />} />

              {/* Service routes with dynamic parameter - THIS MUST BE AFTER MORE SPECIFIC ROUTES */}
              <Route path="/:serviceKey" element={<App />} />
              
              {/* Default route: show DefaultPage when no path is provided */}
              <Route path="/" element={<DefaultPage />} />              {/* Catch-all route for unmatched paths - THIS MUST BE LAST */}
              <Route path="*" element={<NotFoundRedirect />} />            </Routes>
            </RoleProvider>
        </GoogleMapsProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
)
